import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, UsersIcon, PenToolIcon, DollarSignIcon, TrendingUpIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const modules = [{
  number: '01',
  icon: BookOpenIcon,
  title: 'Configura Meta Ads sin errores desde cero',
  description: 'Aprende a configurar tu cuenta correctamente y evita perder dinero desde el inicio.'
}, {
  number: '02',
  icon: UsersIcon,
  title: 'Segmentación de Audiencias',
  description: 'Aprende a encontrar y definir tu audiencia ideal con precisión láser.'
}, {
  number: '03',
  icon: PenToolIcon,
  title: 'Lanza campañas que realmente generan resultados',
  description: 'Aprende a estructurar y crear campañas en Meta Ads desde cero para atraer clientes y empezar a generar resultados reales.'
}, {
  number: '04',
  icon: DollarSignIcon,
  title: 'Invierte mejor y deja de perder dinero en anuncios',
  description: 'Aprende a definir presupuestos, entender la subasta y tomar decisiones que maximicen tus resultados sin gastar de más.'
}, {
  number: '05',
  icon: TrendingUpIcon,
  title: 'Mejora tus resultados y escala lo que sí funciona',
  description: 'Aprende a optimizar tus campañas, interpretar métricas y escalar anuncios ganadores sin aumentar el riesgo.'
}];
export function CurriculumSection() {
  return <section className="w-full bg-gray-50 py-20 sm:py-28" data-id="element-27">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-28">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.1
      }} data-id="element-29">
          {/* Section header */}
          <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-30">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-electric-blue/10 to-bright-orange/10 px-4 py-2 text-sm font-semibold text-electric-blue" data-id="element-31">
              <BookOpenIcon className="h-4 w-4" data-id="element-32" />
              Contenido del curso
            </span>
            <h2 className="mb-4 font-heading text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-33">
              ¿Qué Vas a Aprender?
            </h2>
            <p className="mx-auto max-w-2xl text-lg text-gray-600" data-id="element-34">
              Lo que necesitas para activar tu sistema de clientes en WhatsApp
            </p>
          </motion.div>

          {/* Modules grid */}
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-35">
            {modules.map((module, index) => {
            const IconComponent = module.icon;
            return <motion.div key={index} variants={itemVariants} className="group relative overflow-hidden rounded-2xl bg-white p-6 shadow-lg transition-shadow duration-300 hover:shadow-xl" data-id="element-36">
                  {/* Module number background */}
                  <span className="absolute -right-4 -top-4 font-heading text-8xl font-extrabold text-gray-100 transition-colors group-hover:text-electric-blue/10" data-id="element-37">
                    {module.number}
                  </span>

                  <div className="relative" data-id="element-38">
                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-electric-blue to-bright-orange" data-id="element-39">
                      <IconComponent className="h-6 w-6 text-white" data-id="element-40" />
                    </div>
                    <span className="mb-2 block text-sm font-semibold text-electric-blue" data-id="element-41">
                      Módulo {module.number}
                    </span>
                    <h3 className="mb-2 font-heading text-lg font-bold text-gray-900" data-id="element-42">
                      {module.title}
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-43">
                      {module.description}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>

          {/* Bottom note */}
          <motion.p variants={itemVariants} className="mt-12 text-center text-gray-600" data-id="element-44">
            <span className="font-semibold text-gray-900" data-id="element-45">+20 lecciones</span>{' '}
            en video con ejemplos prácticos y ejercicios
          </motion.p>
        </motion.div>
      </div>
    </section>;
}